import { kAcceptedFilesList, kGcsUserFilesPipelineBucketRef as kPipelineBucketRef } from '@/constants/constants-gcs'
import { kUserFilesValidatedUploadMaxFileSizeBytes } from '@/user_files/limits'

/**
 * GCS bucket for the new user files pipeline
 */
export const kGcsUserFilesPipelineBucketRef = kPipelineBucketRef

/**
 * Uppy max file size restriction
 */
export const kUppyUploadMaxFileSizeBytes = kUserFilesValidatedUploadMaxFileSizeBytes

/**
 * Allowed upload file types in the user files pipeline
 */
export const kUppyUploadAllowedFileTypes: readonly string[] = [...Object.values(kAcceptedFilesList).flat()]

/**
 * Max number of concurrent Firebase uploads when talking to cloud-backed Storage.
 */
export const kUppyUploadMaxConcurrentUploads = 3

/**
 * The Firebase Storage emulator can leave concurrent resumable uploads stuck
 * before finalize in local development. Keep emulator-backed uploads
 * sequential so files reliably enter the backend pipeline.
 */
export const kUppyUploadMaxConcurrentEmulatorUploads = 1

/**
 * Polling interval for checking file processing status (milliseconds)
 */
export const kProcessingPollIntervalMs = 3000
